import React, {FC} from 'react';

import AppLayout from './components/layout/app-layout';
import AppHeader from './components/layout/app-header';

export const App: FC = () => {
    return (
        <div id="erp-app-content" className="d-flex flex-column">
            <AppHeader/>
            <AppLayout/>
        </div>
    );
}

export default App;
